export enum WalletConnectStatus {
  connecting = 'Connecting',
  disconnected = 'Disconnected',
  idle = 'Idle',
  connected = 'Connected'
}

export enum Icon {
  Arrow = 'arrow',
  Copy = 'copy',
  Globe = 'globe',
  Discord = 'discord',
  Dropdown = 'dropdown',
  Info = 'info',
  Locked = 'locked',
  Metamask = 'metamask',
  Ledger = 'ledger',
  Reddit = 'reddit',
  Search = 'search',
  Trash = 'trash',
  Star = 'star',
  Sync = 'sync',
  Telegram = 'telegram',
  Trending = 'trending',
  Twitter = 'twitter',
  Unlocked = 'unlocked',
  Wallet = 'wallet',
  CloseCircle = 'close-circle',
  ExternalLink = 'external-link',
  Sort = 'sort'
}

export enum Modal {
  GovLaunchRedirection = 'gov-launch-redirection',
  ChangeAdmin = 'change-admin',
  CreateTokenPair = 'create-token-pair',
  Connect = 'connect',
  CreateAirdrop = 'create-airdrop',
  Cw20RegisterModal = 'cw20-register-modal',
}

export enum Breakpoint {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xs = 'xs',
  Xxs = 'xxs'
}

export enum BusEvents {
  NavLinkClicked = 'nav-link-clicked',
  ShowLedgerConnect = 'show-ledger-connect',
  WalletConnected = 'wallet-connected',
  Cw20TokenRegistered = 'cw20-token-registered'
}

export enum WalletModalType {
  All = 'all',
  Ledger = 'ledger',
  Trezor = 'trezor'
}
